<template>
   <div>
    <div v-if="!(this.hideAddLead || this.modal)" class="row mt-1 ml-0">
      <a class="btn-link smaller" href="#" @click="addLead">
        <i class="fa fa-plus"></i> Add Lead
      </a><!-- 
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <a class="btn-link smaller" href="#" @click="addLead">
        <i class="fa fa-plus"></i> Add Closed
      </a> -->
    </div>
    <el-table @cell-mouse-enter="rowHover" @cell-mouse-leave="rowHoverLeave"
              @row-click="rowClick"
              id="leadsTable" class="table-striped" 
              :data="leads" :row-class-name="noRowClick?'':'clickableRow'">

      <el-table-column prop="hot" width="40">
        <template slot-scope="{row}">
          <a class="btn-link" :class="row.hot?'btn-red':'btn-greyed d-none showOnHover hideIfLeadClose'"
              @click="toggleHot(row)" v-tooltip.top-center="row.hot?'Hot Lead!':'Hot Lead?'">
            <i class="fas fa-pepper-hot "/>
          </a>
        </template>
      </el-table-column>

      <el-table-column prop="name" label="Name"/>
      <el-table-column v-if="!this.hideContact" prop="mainContactName" label="Contact"/>
      <el-table-column v-if="!(this.hideAffiliate || this.modal)" label="Affiliate">
        <template slot-scope="{row}">
          {{ $store.getters.getAffiliateName(row.affiliateAccountId) }}
        </template>
      </el-table-column>
      <el-table-column v-if="!(this.hideStatus || this.modal)" label="Status">
        <template slot-scope="{row}">
          {{ getStatusLabel(row.status) }}
          <template v-if="row.status == 'received'">
            <a class="btn-link btn-success d-none showOnHover ml-1" v-tooltip.top-center="'Close'"
                @click="changeLeadStatus(row, 'closed')">
              <i class="fad fa-box-check "/>
            </a>
            <a class="btn-link btn-danger d-none showOnHover ml-1" v-tooltip.top-center="'Lost'"
                @click="changeLeadStatus(row, 'lost')">
              <i class="fas fa-window-close "/>
            </a>
          </template>
          <template v-if="row.status == 'closed' || row.status == 'lost'">
            <a class='btn-link btn-success d-none showOnHover ml-1' v-tooltip.top-center="'Reopen'"
                @click="changeLeadStatus(row, 'received')">
              <i class="fas fa-trash-restore-alt "/>
            </a>
          </template>
        </template>
      </el-table-column>
      <el-table-column width="90" label="Date">
        <template slot-scope="{row}">
          {{ displayDate(row) }}
        </template>
      </el-table-column>
      
      <el-table-column width="40">
        <template slot-scope="{row}">
          <a v-if="row.deletable" class="btn-danger btn-link" v-tooltip.top-center="'Delete'"
              @click="deleteLead(row)">
            <i class="fa fa-times"></i>
          </a>
        </template>
      </el-table-column>

      <el-table-column v-if="selectObjects && !($store.getters.modal.current && !modal)" width="30">
        <template slot-scope="{row}">
          <!-- <a class="btn-info btn-link"> <i class="far fa-square"/></a> -->
          <div>
            <l-checkbox v-if="rowSelectable(row)" :id="'selectlead'+row.id" @change="selectRow(row)"/>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="1">
        <template slot-scope="{row}">
          <!-- !!! we need the attribute name to be all lower case !! -->
          <div :leadId="row.id"/> <!-- this is for the onHover method to find the right row onHover -->
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import { Lead } from 'src/classes/datamodel.js'
import utils from '../../utils'
export default {
  name: 'Leads-Table',
  props: {
    filter:         {type: Object, default: null},
    modal:          {type: Boolean, default: false},
    hideAddLead:    {type: Boolean, default: false},
    hideContact:    {type: Boolean, default: false},
    hideAffiliate:  {type: Boolean, default: false},
    hideStatus:     {type: Boolean, default: false},
    noRowClick:     {type: Boolean, default: false},
    toReceiveOnly:  {type: Boolean, default: false}
  },
  data () {
    return {
      dialogModeAffiliate: '',
      dialogVisibleAffiliate: false,
      dialogModeCompany: ''
    }
  },
  computed: { 
    leads () {
      let leads = this.$store.getters.leads
      // We apply the filter if any
      if (this.filter) {
        leads = leads.filter(lead => lead.status == this.filter.value)
      }
      else if (this.toReceiveOnly) {
        leads = leads.filter(lead => lead.status == Lead._status.SUBMITTED.value)
      }
      else {
        leads = leads.filter(lead => lead.status != Lead._status.SUBMITTED.value)
      }
      // If we're in an Affiliate modal, we'll filter the leads on this Affiliate
      let affiliateId = this.$store.getters.modal.object ? this.$store.getters.modal.object.affiliateId : null
      if (affiliateId) {
        leads = leads.filter(lead => lead.affiliateId == affiliateId)
      }
      return leads
    },
    selectObjects () {
      return !!this.$store.getters.selectedObjectsJson
    }
  },
  methods: {
    displayDate (row) {
      // We display the date corresponding to the status of the lead (ex: status = 'closed' => dateClosed)
      let date = null
      switch (row.status) {
        case Lead._status.RECEIVED.value:
          date = row.dateReceived
          break
        case Lead._status.CLOSED.value:
          date = row.dateClosed
          break
        case Lead._status.LOST.value:
          date = row.dateLost
          break
        default:
          date = row.dateCreated
          break
      }
      return utils.dateToString(date)
    },
    getStatusLabel (status) {
      // console.log('this.$store.getters.Lead._status = ', this.$store.getters.Lead._status)
      // console.log('Object.entries(^) = ', Object.entries(this.$store.getters.Lead._status))
      const statusObj = Object.entries(this.$store.getters.Lead._status).find(e => e[1].value == status)[1]
      // console.log('---- statusObj = ', statusObj)
      return statusObj ? statusObj.label : status
    },
    addLead () {
      this.$store.dispatch('openModal', { name: 'Lead', mode: 'Create', object: new Lead({status: Lead._status.RECEIVED.value}) })
    },
    rowHover(row, column, cell, event) {
      // We show all buttons of class .showOnHover
      var rows = $('#leadsTable > div > table > tbody > tr')
      for (var i = 0; i < rows.length; i++) {
        var foundRow = JSON.stringify($(rows[i]).html().indexOf('leadid="'+row.id+'"')) > -1
        if (foundRow) {
          //$(rows[i]).css({'background-color': 'red'})
          //$(rows[i]).css({'border-style': 'solid'})
          var icons = $(rows[i]).find('.showOnHover')
          for (var j = 0; j < icons.length; j++) {
            if (!($(icons[j]).hasClass('hideIfLeadClose') && (row.status == 'closed' || row.status == 'lost'))) {
              $(icons[j]).removeClass('d-none')
            }
          }
          break
        }
      }
    },
    rowHoverLeave (row, column, cell, event) {
      // We hide all buttons of class .showOnHover
      var rows = $('#leadsTable > div > table > tbody > tr')
      for (var i = 0; i < rows.length; i++) {
        var index = JSON.stringify($(rows[i]).html().indexOf('leadid="'+row.id+'"'))
        if (index > -1) {
          //$(rows[i]).css({'border-style': 'hidden'})
          //$(rows[i]).css({'background-color': 'grey'})
          var icons = $(rows[i]).find('.showOnHover')
          for (var j = 0; j < icons.length; j++) {
            $(icons[j]).addClass('d-none')
          }
          break
        }
      }
    },
    rowClick (row, column, event) {
      // if rows are clickable
      if (!this.noRowClick) {
        // We only process the row click if the click didn't happen on a button
        // var match = JSON.stringify(event.toElement.classList.value).match(/fa[rsdl]{0,1}\sfa-|form-check-sign|form-check-input/i)
        var path = event.path || event.composedPath()
        var match = JSON.stringify(path[0].className).match(/fa[rsdl]{0,1}\sfa-|form-check-sign|form-check-input/i)
        //console.log('rowClick():', event.toElement.classList.value)
        if (match && match.index > -1) {
          //console.log('row click ignored')
        } else {
          //console.log('row click!')
          this.editLead(row)
        }
      }
    },
    async editLead (row) {
      if (this.modal) {
        this.$store.dispatch('closeModal')
      }
      this.$store.dispatch('openModal', {name: 'Lead', mode: 'Edit', object: new Lead(row)})
    },
    async changeLeadStatus(row, statusStr) {
      var newLead = new Lead(row)
      //newLead.contacts = new Array(newLead.contacts) // This is because the row (=lead) has weird objects instad of arrays
      var status = null
      switch (statusStr) {
        case 'received':
          status = Lead._status.RECEIVED.value
          break;
        case 'closed':
          status = Lead._status.CLOSED.value
          break;
        case 'lost':
          status = Lead._status.LOST.value
          break;
        default:
          console.log('!!!!! WARNING !!!!! LeadsTable.vue:(changeLeadStatus(), wrong status: ', statusStr)
          break;
      }
      newLead.status = status
      const res = await this.$store.dispatch('updateRestObject', newLead)
      if (res.errors) {
        if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else { this.$notify({ successMessage: 'Saved!'})
      }
    },
    async deleteLead (row) {
      const res = await this.$store.dispatch('deleteRestObject', new Lead(row))
      if (res.errors) {
        if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else { this.$notify({ successMessage: 'Deleted!'})
      }
    },
    async toggleHot (row) {
      let lead = new Lead(row)
      let res = null
      switch (row.hot) {
        case true:
          lead.hot = false
          res = await this.$store.dispatch('updateRestObject', lead)
          break
        case false:
          lead.hot = true
          res = await this.$store.dispatch('updateRestObject', lead)
          break
        default:
          res = {errors: ['Error while trying to toggle the hot status.']}
          console.log('error in LeadsTable.vue:toggleHot(), trying to change hot status of row: ', row)
          break
      }
      if (res.errors) {
        if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else { this.$notify({ successMessage: 'Saved!'})
      }
    },
      // This method is called when clicking a checkbox to select a row
      // It's going to update the ObjectsWithId in the state (selectedObjects.objectsJson)
      selectRow (row) {
        this.$store.commit('SELECT_OBJECT', row)
      },
      rowSelectable(row) {
        if (this.$store.getters.selectedObjectsJson) { // if selection mode is active
          let filter = this.$store.getters.selectedObjectsFilter
          let filterKeys = filter ? Object.keys(filter) : []
          let match = true
          filterKeys.forEach(key => {
            if (row[key] != filter[key]) {
              match = false
            }
          });
          return match
        }
        return false
      }
  },
  mounted () { // tentative to implement a better onHover for the table rows.. doesn't work
      $('.el-table__body').css({'border-collapse': 'collapse'})
      $('.el-table__body .el-table__row').css({'border-width': 'thin'})
      $('.el-table__body .el-table__row').css({'border-color': 'black'})
      $('.el-table__body .el-table__row').css({'border-style': 'hidden'})
  }
}
</script>

<style>

</style>